import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Swiper from 'react-id-swiper';
import { message } from 'antd';
import {
  Player,
  ControlBar,
  Shortcut,
  PlaybackRateMenuButton,
  ReplayControl,
  ForwardControl,
  BigPlayButton,
} from 'video-react';

import 'swiper/css/swiper.css';
import '../../../node_modules/video-react/dist/video-react.css';
import fail from '../../static/msg-fail.svg';

import styles from './Preview.module.less';

export default memo(({ data = [], visible, activeIndex, close }) => {
  const [maskVisible, setMaskVisible] = useState(false);
  const swiperRef = useRef(null);
  const [player, setPlayer] = useState(null);

  const [prevClass, setPrevClass] = useState(styles.swiper_prev_disable);
  const [nextClass, setNextClass] = useState(styles.swiper_next);

  /**
   * 处理视频加载失败问题
   */
  useEffect(() => {
    if (player) {
      player.subscribeToStateChange(e => {
        const { error } = e;
        if (error === 'UNKNOWN ERROR') {
          message.error({
            content: '视频播放失败',
            icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
          });
        }
        // setPause(paused);
      });
    }
  }, [player]);

  useEffect(() => {
    if (visible) {
      setMaskVisible(visible);
    }
  }, [visible]);

  const handleCancel = useCallback(() => {
    close(false);
  }, []);

  const goNext = () => {
    const swiper = swiperRef.current && swiperRef.current.swiper;
    if (swiper) {
      swiper.slideNext();
      if (swiper.slides.length - 1 === swiper.activeIndex) {
        setPrevClass(styles.swiper_prev);
        setNextClass(styles.swiper_next_disable);
      } else {
        setPrevClass(styles.swiper_prev);
        setNextClass(styles.swiper_next);
      }
    }
  };
  const goPrev = () => {
    const swiper = swiperRef.current && swiperRef.current.swiper;
    if (swiper) {
      swiper.slidePrev();
      if (swiper.activeIndex === 0) {
        setPrevClass(styles.swiper_prev_disable);
        setNextClass(styles.swiper_next);
      } else {
        setPrevClass(styles.swiper_prev);
        setNextClass(styles.swiper_next);
      }
    }
  };

  useEffect(() => {
    if (parseInt(activeIndex) !== 0) {
      setPrevClass(styles.swiper_prev);
    } else {
      setPrevClass(styles.swiper_prev_disable);
    }
    if (parseInt(activeIndex) !== data.length - 1) {
      setNextClass(styles.swiper_next);
    } else {
      setNextClass(styles.swiper_next_disable);
    }
  }, [activeIndex, data]);

  useEffect(() => {
    window.onkeydown = e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        goPrev();
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        goNext();
      }
    };
    return () => {
      window.onkeydown = null;
    };
  }, []);

  const params = {
    slidesPerView: 1,
    // spaceBetween: 20,
    allowTouchMove: false,
    // speed: 800,
    // loop: data.length > 1,
    // autoplay: false,
    autoplay: false,
    initialSlide: +activeIndex,
  };

  const handleAnimationEnd = () => {
    if (!visible) {
      setMaskVisible(visible);
    }
  };

  if (!maskVisible) {
    return null;
  }
  return (
    <div
      className={classNames(
        styles.mask,
        {
          [styles.mask_hidden]: !visible,
        },
        { [styles.mask_scale]: visible },
        { [styles.mask_shrink]: !visible },
      )}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className={styles.content_box}>
        <div className={styles.icon}>
          <div className={styles.close} onClick={handleCancel}>
            <i className="iconfont icon-close" />
          </div>
        </div>
        <div className={styles.swiper_box}>
          <div className={styles.swiper}>
            <Swiper {...params} ref={swiperRef}>
              {data.map((item, i) => (
                <div className={'swiper_slide_item'} key={i}>
                  {item.type === '1' ? (
                    <Player
                      src={`${item.url}`}
                      ref={p => setPlayer(p)}
                      className={'swiper_slide_item_player'}
                      fluid={false}
                      playsInline={true}
                      autoPlay={true}
                      muted={true}
                      loop={true}
                      width={`100%`}
                      height={`100%`}
                    >
                      <Shortcut dblclickable={false} />
                      <BigPlayButton position="center" className={styles.player_btn} />
                      <ControlBar
                        autoHide={true}
                        clickable={true}
                        className={styles.player_controlbar}
                      >
                        <ReplayControl seconds={5} order={1.1} />
                        <ForwardControl seconds={5} order={1.1} />
                        <PlaybackRateMenuButton
                          rates={[0.5, '1.0', 1.25, 1.5, '2.0']}
                          className={''}
                        />
                      </ControlBar>
                    </Player>
                  ) : (
                    <img className={'swiper_slide_item_img'} src={item.url} alt="" />
                  )}
                </div>
              ))}
            </Swiper>
          </div>
          {data.length > 1 && <div className={prevClass} onClick={goPrev} />}
          {data.length > 1 && <div className={nextClass} onClick={goNext} />}
        </div>
      </div>
    </div>
  );
});
